import { render, staticRenderFns } from "./roleApplyDialog.vue?vue&type=template&id=84d209a4&scoped=true"
import script from "./roleApplyDialog.vue?vue&type=script&lang=js"
export * from "./roleApplyDialog.vue?vue&type=script&lang=js"
import style0 from "./roleApplyDialog.vue?vue&type=style&index=0&id=84d209a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d209a4",
  null
  
)

export default component.exports